import { useEffect, useState } from "react";
import { apiRequest } from "@vojomo-core/shared";

export interface Source {
  _id: string;
  file_name: string;
  file_type: string;
  updated_at: string;
  topic?: string | { $oid: string };
  is_team?: boolean;
}

export const useSource = (topicId: string = null) => {
  const [sources, setSources] = useState<Source[]>([]);
  const [isLoadingSources, setIsLoadingSources] = useState(true);

  // Fetch available sources
  const fetchSources = async () => {
    setIsLoadingSources(true);

    const data = await apiRequest<Source[]>({
      subRoute: "ai",
      path: `/retrieve_sources?filtered_id=${topicId}`,
      method: "GET"
    });

    setSources(data);

    setIsLoadingSources(false);
  };

  useEffect(() => {
    fetchSources();
  }, [topicId]);

  return {
    sources,
    isLoadingSources,

    fetchSources
  };
};
